import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "@/index.css";
import "@/App.css";
import ParticleBackground from "@/components/ParticleBackground";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TokenTicker from "@/components/TokenTicker";
import BackedBySection from "@/components/BackedBySection";
import FeaturesSection from "@/components/FeaturesSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import SecuritySection from "@/components/SecuritySection";
import MarketOpportunitySection from "@/components/MarketOpportunitySection";
import PricingSection from "@/components/PricingSection";
import AboutSection from "@/components/AboutSection";
import WaitlistSection from "@/components/WaitlistSection";
import Footer from "@/components/Footer";
import AdminDashboard from "@/components/AdminDashboard";

const LandingPage = () => {
  return (
    <div className="relative min-h-screen bg-[#05050A] overflow-x-hidden" data-testid="ghost-app">
      {/* Particle Background */}
      <ParticleBackground />

      {/* Main Content */}
      <div className="relative z-10">
        <Navbar />
        <main>
          <HeroSection />
          <TokenTicker />
          <BackedBySection />
          <FeaturesSection />
          <HowItWorksSection />
          <SecuritySection />
          <MarketOpportunitySection />
          <PricingSection />
          <AboutSection />
          <WaitlistSection />
        </main>
        <Footer />
      </div>
    </div>
  );
};

const AdminPage = () => {
  const navigate = useNavigate();
  
  return (
    <AdminDashboard onBack={() => navigate("/")} />
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
